import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { context } from 'bookingbug-core-js';
import { DataStoreService } from './data-store.service';

@Injectable({
  providedIn: 'root'
})

export class AvailibilityService {

  constructor(
    private DataStore: DataStoreService,
    private http: HttpClient
  ) { }

  async getAvailableDays(today, maxDate) {
    const services = this.DataStore.selectedLocation.services; //$get('days', { company_id: this.DataStore.selectedLocation.id, date: today, edate: maxDate })

    await services.forEach(service => {
      service.$get('days', { company_id: this.DataStore.selectedLocation.id, date: today, edate: maxDate }).then(data => {
        const servDay = {
          serviceid: `${service.id}`,
          days: data.days
        }
        this.DataStore.servicesAvailibility.push(servDay);
      });
    });
  }

  async getTimes(serviceid, date) {

    const headers: HttpHeaders = new HttpHeaders({
      'App-Id': context.appId,
      'App-Key': context.appKey
    }); 

    const url = `${context.apiUrl}/api/v5/${this.DataStore.selectedLocation.id}/times/${date}?service_id=${serviceid}`;
    const response = await this.http.get(url, {headers}).toPromise();
    return response;
  }
}
